<template>
    <!-- v-if="['A','B'].find(el=>el==store.state.user.groupe)" -->
    <div style="margin-top: 100px;" v-if="['A','B','N'].find(el=>el==store.state.user.groupe)">
    <div v-if="['A','B'].find(el=>el==store.state.user.groupe)">
        <v-progress-linear v-if="store.state.waiting" color="antiquewhite" indeterminate></v-progress-linear>
        <div>
            <v-row>
                <v-col>
                    <v-btn style="text-align: center;margin-bottom: 5px;" color="primary" @click="dialogueFiltre=true;statsToGet=''" >
                        Filtre
                    </v-btn>
                </v-col>
                <v-col>
                    <v-btn style="text-align: center;margin-bottom: 5px;" color="primary" @click="dialogueFiltres=true" >
                    Filtres Prédéfinis
                </v-btn>
                </v-col>
                <v-col>
                    <v-btn style="text-align: center;margin-bottom: 5px;" color="green" @click="exportToExcel(statsTable)" >
                        <v-icon icon="mdi-file-excel"></v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <div >
            <v-tabs v-model="tabEtabs" bg-color="grey" height="30">
                <v-tab value="tab_1">TCD</v-tab>
                <v-tab value="tab_2" @click="grapheType='etab';axe={x:'t_etablissement',y:'total_ttc_global'}"> Graphe</v-tab>
                <v-tab value="tab_4" >CrossPoint</v-tab>
                <v-tab value="tab_5" >Stats</v-tab>
            </v-tabs>
            <v-tabs-window v-model="tabEtabs">
                <v-tabs-window-item value="tab_1">
                      <div class="client-table-container">
                        <!-- Tableau principal avec en-têtes -->
                        <table class="client-table">
                        <thead>
                            <tr>
                            <th width="20px" class="iconAdd" style="border: 0.1em solid" 
                                :title="filtreSingleParams.gp_tiers.length > 0 ? 'Voir les statistiques' : 'Sélectionnez des clients'"
                                :class="{ 'disabled-icon': filtreSingleParams.gp_tiers.length === 0 }"
                                @click="filtreSingleParams.gp_tiers.length > 0 ? getStatsTiers('search_ventes') : null">
                                📊
                            </th>
                            <th width="120px" style="border: 0.1em solid">Cde Client</th>
                            <th width="150px" style="border: 0.1em solid">Nom</th>
                            <th width="100px" style="border: 0.1em solid">Prénom</th>
                            <th width="50px" style="border: 0.1em solid">Genre</th>
                            <th width="50px" style="border: 0.1em solid">Age</th>
                            <th width="70px" style="border: 0.1em solid">Tel</th>
                            <th width="150px" style="border: 0.1em solid">email</th>
                            <th width="70px" style="border: 0.1em solid">code Postal</th>
                            <th width="50px" style="border: 0.1em solid">Ratach</th>
                            <th width="50px" style="border: 0.1em solid">Nb.pass</th>
                            <th width="70px" style="border: 0.1em solid">D.Création</th>
                            <th width="70px" style="border: 0.1em solid">D.Modif</th>
                            <!-- <th width="50px" style="border: 0.1em solid">Etab</th> -->
                            <th width="70px" style="border: 0.1em solid">Prem.ACHAT</th>
                            <th width="70px" style="border: 0.1em solid">Dern.Achat</th>
                            <th width="50px" style="border: 0.1em solid">moy. TTC</th>
                            <th width="50px" style="border: 0.1em solid">Nbre</th>
                            <th width="50px" style="border: 0.1em solid">Qte</th>
                            <th width="100px" style="border: 0.1em solid">TOT TTC</th>
                            </tr>
                            <!-- Ligne de filtres -->
                            <tr>
                            <td width="20px" style="border: 0.1em solid">
                                <input type="checkbox" v-model="isChecked" @change="checkTiers(isChecked)">
                            </td>
                            <td width="120px" style="border: 0.1em solid">
                                <input type="text" size="12" v-model="filterTiers.t_tiers" @input="applyFilters">
                            </td>
                            <td width="150px" style="border: 0.1em solid">
                                <input type="text" size="11" v-model="filterTiers.t_libelle" @input="applyFilters">
                            </td>
                            <td width="100px" style="border: 0.1em solid">
                                <input type="text" size="10" v-model="filterTiers.t_prenom" @input="applyFilters">
                            </td>
                            <td width="50px" style="border: 0.1em solid">
                                <input type="text" size="3" v-model="filterTiers.t_sexe" @input="applyFilters">
                            </td>
                            <td width="50px" style="border: 0.1em solid">
                                <input type="text" size="3" v-model="filterTiers.age" @input="applyFilters">
                            </td>
                            <td width="100px" style="border: 0.1em solid">
                                <input type="text" size="8" v-model="filterTiers.t_telephone" @input="applyFilters">
                            </td>
                            <td width="150px" style="border: 0.1em solid">
                                <input type="text" size="12" v-model="filterTiers.t_email" @input="applyFilters">
                            </td>
                            <td width="70px" style="border: 0.1em solid">
                                <input type="text" size="6" v-model="filterTiers.t_codepostal" @input="applyFilters">
                            </td>
                            <td width="50px" style="border: 0.1em solid">
                                <input type="text" size="4" v-model="filterTiers.t_etablissement" @input="applyFilters">
                            </td>
                            <td width="50px" style="border: 0.1em solid">
                                <input type="text" size="4" v-model="filterTiers.nbrpassages" @input="applyFilters">
                            </td>
                            <td width="70px" style="border: 0.1em solid"></td>
                            <td width="70px" style="border: 0.1em solid"></td>
                            <td width="50px" style="border: 0.1em solid">
                                <!-- <input type="text" size="4" v-model="filterTiers.gl_etablissement" @input="applyFilters"> -->
                            </td>
                            <!-- <td width="70px" style="border: 0.1em solid"></td> -->
                            <td width="70px" style="border: 0.1em solid"></td>
                            <td width="50px" style="border: 0.1em solid">
                                <input type="text" size="2" v-model="filterTiers.moyenne_ttc_global" @input="applyFilters">
                            </td>
                            <td width="50px" style="border: 0.1em solid">
                                <input type="text" size="4" v-model="filterTiers.nb_ventes_global" @input="applyFilters">
                            </td>
                            <td width="50px" style="border: 0.1em solid">
                                <input type="text" size="4" v-model="filterTiers.nb_qtestock_global" @input="applyFilters">
                            </td>
                            <td width="100px" style="border: 0.1em solid">
                                <input type="text" size="4" v-model="filterTiers.total_ttc_global" @input="applyFilters">
                            </td>
                            
                            </tr>
                        </thead>
                        </table>

                        <!-- Liste des clients paginée -->
                        <div v-if="paginatedItems.length > 0">
                        <table v-for="tiers in paginatedItems" :key="tiers.gp_tiers" class="client-table">
                            <tbody>
                            <!-- Ligne principale du client -->
                            <tr>
                                <td width="20px" style="border: 0.1em solid; margin-top: 2px;">
                                <input type="checkbox" @change="addTiers(tiers.gp_tiers, tiers.selected)" v-model="tiers.selected">
                                </td>
                                <td width="120px" style="border: 0.1em solid; text-align: left; overflow: hidden;" 
                                    @click="filtreSingleParams.gp_tiers = []; getStatsTiers('search_ventes', tiers.gp_tiers)" 
                                    class="iconAdd clickable">
                                <span style="margin-left: 5px;">{{ tiers.gp_tiers }}</span>
                                </td>
                                <td width="150px" style="border: 0.1em solid; text-align: left; max-width: 150px; text-overflow: ellipsis; overflow: hidden;" 
                                    @click="getClients(tiers.gp_tiers)" class="iconAdd clickable">
                                <span style="margin-left: 5px;">{{ tiers.t_libelle }}</span>
                                </td>
                                <td width="100px" style="border: 0.1em solid">{{ tiers.t_prenom }}</td>
                                <td width="50px" style="border: 0.1em solid">{{ tiers.t_sexe }}</td>
                                <td width="50px" style="border: 0.1em solid">
                                {{ tiers.t_anneenaissance && tiers.t_anneenaissance != '1900' ? tiers.age : '' }}
                                </td>
                                <td width="100px" style="border: 0.1em solid">{{ tiers.t_telephone }}</td>
                                <td width="150px" style="border: 0.1em solid; max-width: 150px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; box-sizing: border-box">
                                {{ tiers.t_email }}
                                </td>
                                <td width="70px" style="border: 0.1em solid">{{ tiers.t_codepostal }}</td>
                                <td width="50px" style="border: 0.1em solid">{{ tiers.t_etablissement }}</td>
                                <td width="50px" style="border: 0.1em solid">{{ tiers.nbrpassages }}</td>
                                <td width="70px" style="border: 0.1em solid">
                                {{ tiers.t_datecreation ? tiers.t_datecreation.split('T')[0] : '' }}
                                </td>
                                <td width="70px" style="border: 0.1em solid">
                                    {{ tiers.t_datemodif ? tiers.t_datemodif.split('T')[0] : '' }}
                                </td>
                                <!-- <td width="50px" style="border: 0.1em solid" 
                                    @click="setVisible(tiers, 'allstats')" class="clickable"
                                >
                                    <v-icon class="iconAdd" icon="mdi-plus"></v-icon>
                                </td> -->
                                <td width="70px" style="border: 0.1em solid">
                                {{ tiers.datepremachat.split('T')[0] }}
                                </td>
                                <td width="70px" style="border: 0.1em solid">
                                {{ tiers.datedernachat.split('T')[0] }}
                                </td>
                                <td width="50px" style="border: 0.1em solid">€ {{ Number(tiers.moyenne_ttc_global).toFixed(2) }}</td>
                                <td width="50px" style="border: 0.1em solid">{{ tiers.nb_ventes_global }}</td>
                                <td width="50px" style="border: 0.1em solid">{{ Number(tiers.nb_qtestock_global).toFixed(0) }}</td>
                                <td width="100px" style="text-align: left; border: 0.1em solid">
                                <span style="text-align: left;">€ </span>{{ Number(tiers.total_ttc_global).toFixed(0) }}
                                </td>
                                <!-- <td width="100px" v-if="tiers.rayon_unique" style="border: 0.1em solid">{{ tiers.rayon_unique }}</td> -->
                            </tr>
                            
                            <!-- Lignes des établissements -->
                            <!-- <tr v-for="etab in getVisibleEtabs(tiers.t_tiers)" :key="etab.gl_etablissement">
                                <td width="20px"></td>
                                <td width="120px"></td>
                                <td width="150px"></td>
                                <td width="100px"></td>
                                <td width="50px"></td>
                                <td width="50px"></td>
                                <td width="100px"></td>
                                <td width="70px"></td>
                                <td width="50px"></td>
                                <td width="50px"></td>
                                <td width="50px"></td>
                                <td width="70px"></td>
                                <td width="70px"></td>
                                <td width="50px" style="border: 0.1em solid">{{ etab.gl_etablissement }}</td>
                                <td width="70px" style="border: 0.1em solid">
                                {{ etab.premiere_vente_etablissement.split('T')[0] }}
                                </td>
                                <td width="70px" style="border: 0.1em solid">
                                {{ etab.derniere_vente_etablissement.split('T')[0] }}
                                </td>
                                <td width="50px" style="border: 0.1em solid">{{ etab.nb_ventes_etablissement }}</td>
                                <td width="50px" style="border: 0.1em solid">{{ Number(etab.total_qtestock_etablissement).toFixed(0) }}</td>
                                <td width="100px" style="text-align: left; border: 0.1em solid">
                                <span style="text-align: left;">€ </span>{{ etab.total_ttc_etablissement }}
                                </td>
                            </tr> -->
                            </tbody>
                        </table>
                        </div>

                        <!-- Message si aucun résultat -->
                        <div v-else class="no-results">
                        Aucun client trouvé
                        </div>

                        <!-- Pagination -->
                        <div class="pagination-container">
                        <div class="pagination-info">
                            Affichage de {{ startIndex + 1 }} à {{ Math.min(endIndex, filteredItems.length) }} 
                            sur {{ filteredItems.length }} client(s)
                            <span v-if="selectedCount > 0">({{ selectedCount }} sélectionné(s))</span>
                        </div>
                        
                        <div class="pagination-controls">
                            <!-- Sélecteur d'éléments par page -->
                            <div class="items-per-page">
                            <label for="itemsPerPage">Par page:</label>
                            <select id="itemsPerPage" v-model="itemsPerPage" @change="resetPage">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            </div>
                            
                            <!-- Navigation de pagination -->
                            <div class="pagination-nav">
                            <button @click="firstPage" :disabled="currentPage === 1" title="Première page">
                                &lt;&lt;
                            </button>
                            <button @click="prevPage" :disabled="currentPage === 1" title="Page précédente">
                                &lt;
                            </button>
                            
                            <!-- Pages numérotées -->
                            <div class="page-numbers">
                                <template v-for="pageNum in visiblePages" :key="pageNum">
                                <button 
                                    @click="goToPage(pageNum)" 
                                    :class="{ active: pageNum === currentPage }"
                                    :disabled="pageNum === '...'">
                                    {{ pageNum }}
                                </button>
                                </template>
                            </div>
                            
                            <button @click="nextPage" :disabled="currentPage === pageCount" title="Page suivante">
                                &gt;
                            </button>
                            <button @click="lastPage" :disabled="currentPage === pageCount" title="Dernière page">
                                &gt;&gt;
                            </button>
                            </div>
                        </div>
                        </div>
                    </div>
                </v-tabs-window-item>
                <v-tabs-window-item value="tab_0" v-if="false">
                    <table>
                        <thead>
                            <tr>
                                <th width="20px" disabled @click="filtreSingleParams.gp_tiers.length>0?getStatsTiers('search_ventes'):''" class="iconAdd" style="border: 0.1em  solid">📊</th>
                                <th width="120px"   style="border: 0.1em  solid">Cde Client</th>
                                <th width="150px"   style="border: 0.1em  solid">Nom</th>
                                <th width="100px"   style="border: 0.1em  solid">Prénom</th>
                                <th width="50px"   style="border: 0.1em  solid">Genre</th>
                                <th width="50px"  style="border: 0.1em  solid">Age</th>
                                <th width="70px"  style="border: 0.1em  solid">Tel</th>
                                <th width="150px"  style="border: 0.1em  solid">email</th>
                                <th width="70px"  style="border: 0.1em  solid">code Postal</th>
                                <th width="50px"  style="border: 0.1em  solid">Ratach</th>
                                <th width="50px"  style="border: 0.1em  solid">Nb.pass</th>
                                <th width="70px"  style="border: 0.1em  solid">D.Création</th>
                                <th width="70px"  style="border: 0.1em  solid">D.Modif</th>
                                <th width="50px"  style="border: 0.1em  solid">Etab</th>
                                <th width="70px"  style="border: 0.1em  solid">Prem.ACHAT</th>
                                <th width="70px"  style="border: 0.1em  solid">Dern.Achat</th>
                                <th width="50px"  style="border: 0.1em  solid">Nbre</th>
                                <th width="100px"  style="border: 0.1em  solid">TOT TTC</th>
                            </tr>
                            <tr>
                                <td width="20px"   style="border: 0.1em  solid"><input type="checkbox" v-model="isChecked" @change="checkTiers(isChecked)"></td>
                                <td width="120px"   style="border: 0.1em  solid"><input type="text" size="12" v-model="filterTiers.t_tiers"></td>
                                <td width="150px"   style="border: 0.1em  solid"><input type="text" size="12"  v-model="filterTiers.t_libelle"></td>
                                <td width="100px"   style="border: 0.1em  solid"><input type="text" size="10" v-model="filterTiers.t_prenom"></td>
                                <td width="50px"   style="border: 0.1em  solid"><input type="text" size="3" v-model="filterTiers.t_sexe"></td>
                                <td width="50px"  style="border: 0.1em  solid"><input type="text" size="3" v-model="filterTiers.age"></td>
                                <td width="100px"  style="border: 0.1em  solid"><input type="text" size="8" v-model="filterTiers.t_telephone"></td>
                                <td width="150px"  style="border: 0.1em  solid"><input type="text" size="12" v-model="filterTiers.t_email"></td>
                                <td width="70px"  style="border: 0.1em  solid"><input type="text" size="6" v-model="filterTiers.t_codepostal"></td>
                                <td width="50px"  style="border: 0.1em  solid"><input type="text" size="4" v-model="filterTiers.t_etablissement"></td>
                                <td width="50px"  style="border: 0.1em  solid"><input type="text" size="4" v-model="filterTiers.nbrpassages"></td>
                                <td width="70px"  style="border: 0.1em  solid"></td>
                                <td width="70px"  style="border: 0.1em  solid"></td>
                                <td width="50px"  style="border: 0.1em  solid"><input type="text" size="4" v-model="filterTiers.gl_etablissement"></td>
                                <td width="70px"  style="border: 0.1em  solid"></td>
                                <td width="70px"  style="border: 0.1em  solid"></td>
                                <td width="50px"  style="border: 0.1em  solid"></td>
                                <td width="100px"  style="border: 0.1em  solid"></td>
                                <!-- <td width="100px"  style="border: 0.1em  solid"></td> -->
                            </tr>
                        </thead>
                    </table>
        
                    <table v-for="tiers in statsTableFiltred">
                        <tbody>
                            <tr >
                                <td width="20px" style="border: 0.1em  solid;margin-top: 2px;"><input type="checkbox" @change="addTiers(tiers.gp_tiers,tiers.selected)" v-model="tiers.selected" ></td>
                                <td width="120px" style="border: 0.1em  solid;text-align: left;overflow: hidden;" @click="filtreSingleParams.gp_tiers=[];statsTiersDialog=true;getStatsTiers('search_ventes',tiers.gp_tiers);getClients(tiers.gp_tiers)" class="iconAdd"><span style="margin-left: 5px;">{{ tiers.gp_tiers }}</span></td>
                                <td width="150px" style="border: 0.1em  solid;text-align: left;max-width: 150px;text-overflow: ellipsis;overflow: hidden;" @click="getClients(tiers.gp_tiers)"  class="iconAdd"><span style="margin-left: 5px;">{{ tiers.t_libelle }}</span></td>
                                <td width="100px" style="border: 0.1em  solid">{{ tiers.t_prenom }}</td>
                                <td width="50px" style="border: 0.1em  solid">{{ tiers.t_sexe }}</td>
                                <td width="50px" style="border: 0.1em  solid">{{ tiers.t_anneenaissance&&tiers.t_anneenaissance!='1900'?new Date().getFullYear()-tiers.t_anneenaissance:'' }}</td>
                                <td width="100px" style="border: 0.1em  solid">{{ tiers.t_telephone }}</td>
                                <td width="150px" style="border: 0.1em  solid;max-width: 150px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;box-sizing: border-box">{{ tiers.t_email }}</td>
                                <td width="70px" style="border: 0.1em  solid">{{ tiers.t_codepostal }}</td>
                                <td width="50px" style="border: 0.1em  solid">{{ tiers.t_etablissement }}</td>
                                <td width="50px"  style="border: 0.1em  solid">{{ tiers.nbrpassages }}</td>
                                <td width="70px" style="border: 0.1em  solid">{{ tiers.t_datecreation?tiers.t_datecreation.split('T')[0]:'' }}</td>
                                <td width="70px" style="border: 0.1em  solid">{{ tiers.t_datemodif?tiers.t_datemodif.split('T')[0]:'' }}</td>
                                <td width="50px" style="border: 0.1em  solid" @click="setVisible(tiers,'allstats')"><v-icon class="iconAdd" icon="mdi-plus"></v-icon></td>
                                <td width="70px" style="border: 0.1em  solid">{{ tiers.premiere_vente_global.split('T')[0] }}</td>
                                <td width="70px" style="border: 0.1em  solid">{{ tiers.derniere_vente_global.split('T')[0] }}</td>
                                <td width="50px" style="border: 0.1em  solid">{{ totalTiers(tiers).totalQte }}</td>
                                <td width="100px" style="text-align: left;border: 0.1em  solid"><span style="text-align: left;">€  </span>{{ Number(totalTiers(tiers).totalTTC).toFixed(2) }}</td>
                                <!-- <td width="100px" v-if="tiers.rayon_unique"  style="border: 0.1em  solid">{{ tiers.rayon_unique }}</td> -->
                            </tr>
                            <!-- <tr v-for="etab in stats[tiers.t_tiers]" v-if="stats[tiers.t_tiers]&&stats[tiers.t_tiers][Object.keys(stats[tiers.t_tiers])[0]]&&stats[tiers.t_tiers][Object.keys(stats[tiers.t_tiers])[0]].visible" >
                                <td width="20px"  ></td>
                                <td width="120px"  ></td>
                                <td width="150px"  ></td>
                                <td width="100px"  ></td>
                                <td width="50px"  ></td>
                                <td width="50px"  ></td>
                                <td width="100px"  ></td>
                                <td width="70px"  ></td>
                                <td width="50px"  ></td>
                                <td width="50px"  ></td>
                                <td width="50px"  ></td>
                                <td width="70px"  ></td>
                                <td width="70px"  style="border: 0.1em  solid"></td>
                                <td width="50px"   style="border: 0.1em  solid">{{etab.gl_etablissement}}</td>
                                <td width="70px"  style="border: 0.1em  solid">{{ etab.premiere_vente_etablissement.split('T')[0] }}</td>
                                <td width="70px"  style="border: 0.1em  solid">{{ etab.derniere_vente_etablissement.split('T')[0] }}</td>
                                <td width="50px"   style="border: 0.1em  solid">{{etab.nb_ventes_etablissement}}</td>
                                <td width="100px"   style="text-align: left;border: 0.1em  solid"><span style="text-align: left;">€     </span>{{etab.total_ttc_etablissement}}</td>
                            </tr> -->
                        </tbody>
                    </table>
                </v-tabs-window-item>
                <v-tabs-window-item value="tab_2">
                    <div width="1000px">
                        <table>
                            <tbody>
                                <tr>
                                    <td width="150px">
                                        <v-select
                                        :items="['t_codepostal','t_ville','t_etablissement','t_pays','t_sexe','t_anneenaissance','t_juridique','nbrpassages']"
                                        density="compact"
                                        variant="outlined"
                                        label="Axe X"
                                        v-model="axe.x"
                                        ></v-select>
                                    </td>
                                    <td width="150px" >
                                        <v-select
                                            style="margin-left: 5px;"
                                            variant="outlined"
                                            :items="['nb_ventes_global','total_ttc_global','nb_qtestock_global']"
                                            density="compact"
                                            label="Axe Y"
                                            v-model="axe.y"
                                        ></v-select>
                                    </td>
                                    
                                    <td width="150px">
                                        <v-select
                                            style="margin-left: 5px;"
                                            :items="['TCD','GLOBAL']"
                                            density="compact"
                                            label="Source"
                                            v-model="axe.source"
                                            variant="outlined"
                                        ></v-select>
                                    </td>
                                    <td width="100px">
                                        <v-switch style="margin-left: 5px;" v-model="isBarChart" :label="isBarChart ? '📊' : '🥧'"></v-switch>
                                    </td>
                                    <td width="100px" >
                                        <v-switch  v-model="axe.showPercent" :label="axe.showPercent ? '%' : '€'"></v-switch>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div >
                        
                                <!-- Graphique -->
                                <div v-if="!isBarChart" class="chart-container-pie">
                                    <Pie   :data="chartData" :options="pieOptions" />
                                    
                                <!-- Graphique -->
                                </div>
                                <div v-if="isBarChart" class="chart-container-bar">
                                    <Bar   :data="chartData" :options="barOptions" />
                                </div>
                        </div>
                    </div>
                </v-tabs-window-item>
                <!-- <v-tabs-window-item value="tab_3">
                    
                </v-tabs-window-item> -->
                <v-tabs-window-item value="tab_4">
                    <Crosspoint></Crosspoint>
                </v-tabs-window-item>
                <v-tabs-window-item value="tab_5">
                    <Statistiques></Statistiques>
                </v-tabs-window-item>
            </v-tabs-window> 
        </div>
                        

        <!-- Zone de déclenchement du lazy loading -->
        <div ref="observerTarget" class="observer-target"></div>

        <!-- Indicateur de chargement pour le lazy loading -->
        <div v-if="loadingMore" class="loading-indicator">
        Chargement des données...
        </div>


        <!-- Bouton de chargement manuel (fallback) -->
        <!-- <v-btn 
        v-if="hasMoreData && !loadingMore" 
        @click="loadMore" 
        class="load-more-btn"
        >
        Charger plus
        </v-btn> -->
    </div>
    <!-- <div  class="text-center" > -->
    <v-dialog
        v-model="dialogStatsTiers"
        persistent
        width="auto"
    >
        <v-card
        :prepend-icon="`${tabTiers=='tab_3'?'mdi-account-file-text':'mdi-google-analytics'}`"
        :title="`${tabTiers=='tab_3'?'Fiche':'Statistiques'} ${filtreSingleParams.gp_tiers&&filtreSingleParams.gp_tiers.length==1?'Client : '+(tiersTable[0].t_prenom?tiersTable[0].t_prenom:'')+' '+tiersTable[0].t_libelle+ ' '+tiersTable[0].gp_tiers:' Générale' }` "
        >
        <v-card-text v-if="statsTiersDialog">
                <v-tabs v-model="tabTiers" bg-color="grey" height="30">
                    <v-tab value="tab_1">TCD</v-tab>
                    <v-tab value="tab_2"> Graphe</v-tab> 
                    <v-tab v-if="filtreSingleParams.gp_tiers&&filtreSingleParams.gp_tiers.length==1" value="tab_3"> Info</v-tab> 
                </v-tabs>
                <v-tabs-window v-model="tabTiers">
                    <v-tabs-window-item value="tab_1">
                        <div style="text-align: center;">
                            <div >
                                <table>
                                    <thead>
                                        <tr>
                                            <th width="50px"   style="border: 0.1em  solid">Etab</th>
                                            <th width="100px"   style="border: 0.1em  solid">Ticket</th>
                                            <th width="100px"   style="border: 0.1em  solid">Date</th>
                                            <th width="50px"   style="border: 0.1em  solid">ligne</th>
                                            <th width="50px"   style="border: 0.1em  solid">Qte</th>
                                            <th width="100px"  style="border: 0.1em  solid">TOT TTC</th>
                                            <th v-if="getElement(statsTiers,3).visible.ligne " width="100px"  style="border: 0.1em  solid">Motif Remise</th>
                                            <th v-if="getElement(statsTiers,3).visible.ligne " width="100px"  style="border: 0.1em  solid">Marque</th>
                                            <th v-if="getElement(statsTiers,3).visible.ligne " width="100px"  style="border: 0.1em  solid">Code Barre</th>
                                            <th v-if="getElement(statsTiers,3).visible.ligne " width="100px"  style="border: 0.1em  solid">sousfamille</th>
                                            <!--<th width="50px"  style="border: 0.1em  solid">Ratach</th>
                                            <th width="70px"  style="border: 0.1em  solid">D.Création</th>
                                            <th width="70px"  style="border: 0.1em  solid">D.Modif</th>
                                            <th width="70px"  style="border: 0.1em  solid">D.den ACHAT</th>
                                            <th width="70px"  style="border: 0.1em  solid">D.Modif</th>
                                            <th width="50px"  style="border: 0.1em  solid">Etab</th>
                                            <th width="50px"  style="border: 0.1em  solid">Qte</th>
                                            <th width="100px"  style="border: 0.1em  solid">TOT TTC</th> -->
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div v-for="etab in statsTiers">
                                <!-- {{ getElement(etab,4).gl_etablissement}} -->
                                <!-- {{ etab }} -->
                                <table>
                                    <tbody>
                                        <tr>
                                            <td width="50px" style="border: 0.1em  solid;text-align: left;"><span>{{ getElement(etab,4).gl_etablissement }}</span></td>
                                            <td width="100px" style="border: 0.1em  solid" @click="setVisible(getElement(etab,4),'ticket')"><v-icon class="iconAdd" icon="mdi-plus"></v-icon></td>
                                            <td width="100px" style="border: 0.1em  solid"></td>
                                            <td width="50px" style="border: 0.1em  solid"></td>
                                            <td width="50px" style="border: 0.1em  solid">{{ totalTiersDetails(getElement(etab,4).gl_etablissement).totalQte }}</td>
                                            <td width="100px" style="border: 0.1em  solid">{{ totalTiersDetails(getElement(etab,4).gl_etablissement).totalTTC }}</td>
                                            <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid"></td>
                                            <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid"></td>
                                            <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid"></td>
                                            <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid"></td>
                                    </tr>
                                    </tbody>
                                </table>                    
                                <div v-for="numero in etab" v-if="getElement(etab,4).visible.ticket">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width="50px" ></td>
                                                <td width="100px" style="border: 0.1em  solid">{{ getElement(numero,5).numero }}</td>
                                                <td width="100px" style="border: 0.1em  solid">{{ getElement(numero,5).date_vente.split('T')[0] }}</td>
                                                <td width="50px" style="border: 0.1em  solid" @click="setVisible(getElement(numero,5),'ligne')"><v-icon class="iconAdd" icon="mdi-plus"></v-icon></td>
                                                <td width="50px" style="border: 0.1em  solid">{{ totalTiersDetails(getElement(numero,5).gl_etablissement,getElement(numero,5).numero).totalQte }}</td>
                                                <td width="100px" style="border: 0.1em  solid">{{ totalTiersDetails(getElement(numero,5).gl_etablissement,getElement(numero,5).numero).totalTTC }}</td>
                                                <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid"></td>
                                                <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid"></td>
                                                <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid"></td>
                                                <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid"></td>
                                            </tr>
                                            <tr v-for="numligne in numero" v-if="getElement(numero,5).visible.ligne">
                                                <td width="50px" ></td>
                                                <td width="100px" ></td>
                                                <td width="100px" ></td>
                                                <td width="50px" style="border: 0.1em  solid">{{ numligne.gl_numligne }}</td>
                                                <td width="50px" style="border: 0.1em  solid">{{ Number(numligne.gl_qtestock).toFixed(0) }}</td>
                                                <td width="100px" style="border: 0.1em  solid">{{ numligne.gl_totalttc }}</td>
                                                <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid">{{ numligne.motif_remise }}</td>
                                                <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid">{{ numligne.marque }}</td>
                                                <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid" class="iconAdd" @click="getArticles(numligne )">{{ numligne.codebarre }}</td>
                                                <td v-if="getElement(statsTiers,3).visible.ligne " width="100px" style="border: 0.1em  solid">{{ numligne.ga_familleniv3 }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> 
                        </div>
                    </v-tabs-window-item>
                    <v-tabs-window-item value="tab_2">
                        <div width="900px">
                            <table>
                                <tbody>
                                    <tr>
                                        <!-- <v-btn density="compact" @click="statsToGet='all';dialogueFiltre=true" icon="mdi-plus" style="margin-top: 15px;" ></v-btn> -->
                                        <td width="150px">
                                            <v-select  
                                            variant="outlined"
                                            :items="['gl_etablissement','marque','theme','rayon','famille','sousfamille','gl_collection','annee','mois','semaine','motif_remise']"
                                            density="compact"
                                            label="Axe X"
                                            v-model="axe.x"
                                            ></v-select>
                                        </td>
                                        <td width="150px" style="margin-left: 10px;">
                                            <v-select
                                                variant="outlined"
                                                :items="['gl_qtestock','gl_totalttc']"
                                                density="compact"
                                                label="Axe Y"
                                                v-model="axe.y"
                                            ></v-select>
                                        </td>
                                        <td width="70px">
                                            <v-switch  v-model="isBarChart" :label="isBarChart ? '📊' : '🥧'"></v-switch>
                                        </td>
                                        <td width="70px">
                                            <v-switch  v-model="axe.showPercent" :label="axe.showPercent ? '%' : '€'"></v-switch>
                                        </td>
                                        
                                        <td width="170px" style="margin-left: 10px;"> 
                                            <v-text-field density="compact" v-model="filtreSingleParams.date_debut" label="Date début" type="date" variant="outlined"></v-text-field>
                                        </td>
                                        <td width="170px" style="margin-left:10px;">
                                            <v-text-field density="compact" v-model="filtreSingleParams.date_fin" label="Date fin" type="date" variant="outlined"></v-text-field>
                                        </td>
                                        <!-- <td width="50px" style="margin-left:10px;"> -->
                                        <v-btn style="margin-top: 8px;margin-left: 10px;"
                                            density="compact"
                                            :loading="loading"
                                            @click="loading=true;getStatsTiers('search_ventes')"
                                            aria-label="Refresh"
                                            icon="mdi-refresh"
                                        ></v-btn>
                                        <v-btn :disabled="!readyToExport" density="compact" style="margin-top: 8px;;margin-left: 10px;" color="green" @click="exportToExcel(tiersTable)" >
                                            <v-icon icon="mdi-file-excel"></v-icon>
                                        </v-btn>
                                        <!-- </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div   class="chart-container">
                            <div style="height: 400px">
                                <Pie  v-if="!isBarChart" :data="chartData" :options="pieOptions" />
                                <Bar  v-if="isBarChart" :data="chartData" :options="barOptions" />
                            </div>
                        </div>
                    </v-tabs-window-item>
                    <v-tabs-window-item value="tab_3" style="margin: 20px;" >
                        <v-row >
                            <v-col  cols="12" md="1">
                                <v-text-field density="compact" label="Genre" v-model="tiers.t_sexe" variant="outlined"></v-text-field>
                            </v-col>
                            <v-col  cols="12" md="3">
                                <v-text-field density="compact" v-model="tiers.t_prenom" label="Prénom" variant="outlined"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" >
                                <v-text-field density="compact" v-model="tiers.t_libelle" label="Nom" variant="outlined"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field density="compact" variant="outlined"
                                    v-model="tiers.t_datecreation.split('T')[0]"
                                    label="Date Création"
                                    date
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field density="compact" variant="outlined"
                                    v-model="tiers.t_datemodif.split('T')[0]"
                                    label="Date Modification"
                                    date
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field density="compact" variant="outlined"
                                    v-model="tiers.t_datenaissance"
                                    label="Date de naissance"
                                    type="date"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12"  md="2">
                                <v-text-field density="compact" v-model="tiers.t_telephone" label="Téléphone" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12" md="4">
                                <v-text-field density="compact" v-model="tiers.t_email" label="E-mail" variant="outlined"></v-text-field>
                            </v-col> 
                            
                            <v-col  cols="12"  md="2">
                                <v-text-field density="compact" variant="outlined" label="TVA" v-model="tiers.t_siret" :rules="[v => !v || /^BE\d{10}$/.test(v) || 'Format: BE0123456789']"></v-text-field>
                            </v-col>
                             <v-col  cols="12"  md="1">
                                <v-checkbox density="compact" variant="outlined" label="Emailing" v-model="tiers.t_emailing"></v-checkbox>
                            </v-col>
                            <v-col cols="12"  md="4">
                                <v-text-field  density="compact" v-model="tiers.t_adresse1" label="Adresse" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12"  md="2">
                                <v-text-field density="compact" v-model="tiers.t_codePostal" label="Code Postal" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12" md="3">
                                <v-text-field density="compact" v-model="tiers.t_ville" label="Ville" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12"  md="2">
                                <v-text-field density="compact" v-model="tiers.t_pays" label="Pays" variant="outlined"></v-text-field>
                            </v-col> 
                        </v-row>
                        <v-row>
                            <v-col cols="12"  md="2">
                                <v-text-field density="compact" v-model="tiers.numcartefid" label="Carte Fid" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12"  md="1">
                                <v-text-field density="compact" v-model="tiers.nbre_achat" label="Nbre Achat" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12" md="1">
                                <v-text-field density="compact" v-model="tiers.nbrpassages" label="Nbre Pass" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12"  md="1">
                                <v-text-field density="compact" v-model="tiers.points_fidelite" label="Points Fid" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12" md="2">
                                <v-text-field density="compact" v-model="tiers.datepremachat.split('T')[0]" type="date" label="Prem Achat" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12"  md="2">
                                <v-text-field  density="compact" v-model="tiers.datedernachat.split('T')[0]" type="date" label="Dern Achat" variant="outlined"></v-text-field>
                            </v-col> 
                            <v-col cols="12"  md="2">
                                <v-text-field  density="compact" v-model="tiers.montantpremachat" prefix="€" label="Min Achat" variant="outlined"></v-text-field>
                            </v-col>
                            <v-col cols="12"  md="2">
                                <v-text-field  density="compact" v-model="tiers.montantdernachat" prefix="€" label="Max Achat" variant="outlined"></v-text-field>
                            </v-col> 
                        </v-row>
                    </v-tabs-window-item>
                </v-tabs-window>
        </v-card-text>
        <v-card-text v-if="!statsTiersDialog">
            <div max-width="1000px">
                <v-data-table 
                    :headers="filtredHeaders"
                    :items="statsTableFilters"
                    :width="1000"
                    fixed-header
                    fixed-height
                    density="compact"
                    item-key="name"
                ></v-data-table>
                <!-- <Pivot></Pivot> -->
                <!-- <PivotTable></PivotTable> -->
            </div>
        </v-card-text>
        
        
        

        <template v-slot:actions>
            <v-btn v-if="tabTiers!='tab_3'"
            class="ms-auto"
            text="Ok"
            @click="dialogStatsTiers = false"
            ></v-btn>
            <v-btn v-if="route.query.client_id&&tabTiers=='tab_3'"
            class="ms-auto"
            color="success"
            text="Exporter"
            @click="exportClient();dialogStatsTiers = false"
            ></v-btn>
        </template>
        </v-card>
    </v-dialog>
    
        
        
    <div  class="text-center" >
        <v-dialog 
            v-model="dialogueFiltreTiers"
            max-width="600"
            width="600" >
            <v-card  prepend-icon="mdi-shopping-search" 
            text="Veillez changer les dates"
            title="Filtrage"
            >
            
                <v-card-text >
                    <!-- <div class="d-flex justify-center"> -->
                        <v-row style="margin-top: 10px">
                            <v-col  cols="12" md="5" sm="12">
                                <v-text-field clearable type="date" label="Date Début" v-model="filtreSingleParams.date_debut" variant="outlined"></v-text-field>
                            </v-col>
                            <v-col  cols="12" md="5" sm="12">
                                <v-text-field type="date" clearable  label="Date Fin" v-model="filtreSingleParams.date_fin" variant="outlined"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col  cols="12" md="5" sm="12">
                                <v-checkbox style="margin-top: -45px"
                                    v-model="exclureDate"
                                    label="Exclure des dates"
                                ></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row v-if="exclureDate" style="margin-top: -45px;">
                            <v-col  cols="12" md="5" sm="12">
                                <v-text-field clearable type="date" label="Date Début Exclu" v-model="filtreSingleParams.date_debut_exclu" variant="outlined"></v-text-field>
                            </v-col>
                            <v-col  cols="12" md="5" sm="12">
                                <v-text-field type="date" clearable  label="Date Fin Exclu" v-model="filtreSingleParams.date_fin_exclu" variant="outlined"></v-text-field>
                            </v-col>
                        </v-row>
                                
                    </v-card-text>
                    <v-card-actions>
                        <div class="d-flex justify-space-between w-100">
                            <v-btn 
                                text="Annuler"
                                @click="dialogueFiltreTiers=false"
                                color="warning"
                            ></v-btn>
                            <v-btn 
                                text="Lancer la recherche"
                                @click="loading=true;getStatsTiers('search_ventes');dialogueFiltreTiers=false"
                                color="primary"
                            ></v-btn>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    <div  class="text-center" >
        <v-dialog 
        v-model="dialogueFiltre"
        max-width="600"
        width="600" >
            <v-card  prepend-icon="mdi-shopping-search" 
            :text="typeFiltre(tab)"
            title="Filtrage"
            >
                <v-card-text >
                    <v-tabs-window v-model="tab" >
                        <v-tabs-window-item value="tab_1">
                                <v-row style="margin-top: 10px">
                                    <v-col  cols="12" md="5" sm="12">
                                        <v-text-field clearable type="date" label="Date Début" v-model="filtreParams.date_debut" variant="outlined"></v-text-field>
                                    </v-col>
                                    <v-col  cols="12" md="5" sm="12">
                                        <v-text-field type="date" clearable  label="Date Fin" v-model="filtreParams.date_fin" variant="outlined"></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col  cols="12" md="5" sm="12">
                                        <v-checkbox style="margin-top: -45px"
                                            v-model="exclureDate"
                                            label="Exclure des dates"
                                        ></v-checkbox>
                                    </v-col>
                                </v-row>
                            <!-- </div> -->
                            <!-- <div v-if="exclureDate" class="d-flex justify-center" style="margin-top: -35px;"> -->
                                <v-row v-if="exclureDate" style="margin-top: -45px;">
                                    <v-col  cols="12" md="5" sm="12">
                                        <v-text-field clearable type="date" label="Date Début Exclu" v-model="filtreParams.date_debut_exclu" variant="outlined"></v-text-field>
                                    </v-col>
                                    <v-col  cols="12" md="5" sm="12">
                                        <v-text-field type="date" clearable  label="Date Fin Exclu" v-model="filtreParams.date_fin_exclu" variant="outlined"></v-text-field>
                                    </v-col>
                                </v-row>
                                
                            <!-- </div> -->
                        </v-tabs-window-item>
                        <v-tabs-window-item value="tab_2">
                                <v-row style="margin-top: 10px;">
                                    <v-col  cols="12" md="6" sm="12">
                                        <!-- <v-text-field clearable label="Filliale"  v-model="filtreParams.filliale" variant="outlined" ></v-text-field> -->
                                        <v-combobox  variant="outlined" clearable label="Filliales" :items="itemsFilliale" multiple item-value="code" item-title="Libelle"
                                            v-model="filtreParams.filliale"
                                        ></v-combobox>
                                    </v-col>
                                    <v-col  cols="12" md="6" sm="12">
                                        <v-combobox clearable label="Etablissements" :items="itemMagasinsOriginalOrder" multiple variant="outlined"
                                            v-model="filtreParams.gl_etablissement"
                                            
                                        ></v-combobox>
                                        <!-- <v-text-field clearable label="Etablissement"  v-model="filtreParams.gl_etablissement" variant="outlined" ></v-text-field> -->
                                    </v-col>
                                    <v-col  cols="12" md="4" sm="12">
                                        <v-text-field clearable label="Promotions"  v-model="filtreParams.motif_remise" variant="outlined" ></v-text-field>
                                    </v-col>
                                </v-row>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="tab_3">
                            <v-row>
                                <v-col  cols="12" md="6" sm="12">
                                    <v-combobox
                                        clearable chips multiple label="Marques" :items="store.state.marques" v-model="filtreParams.ga_libreart1" variant="outlined"
                                    ></v-combobox>
                                </v-col>
                                <v-col  cols="12" md="6" sm="12">
                                    <v-combobox
                                        clearable chips multiple label="Thèmes"  :items="itemsThemes" v-model="filtreParams.code_theme" variant="outlined"
                                    ></v-combobox>
                                </v-col>
                            </v-row>
                                
                        </v-tabs-window-item>
                        <v-tabs-window-item value="tab_4">
                                <v-row> 
                                    <v-col  cols="12" md="4" sm="6">
                                        <v-combobox
                                            clearable chips multiple label="Pôles" :items="store.state.itemsPoles" v-model="filtreParams.codepole" variant="outlined"
                                            item-value="code" item-title="libelle"
                                            ></v-combobox>
                                        <!-- <v-text-field clearable label="pole"  v-model="filtreParams.codepole" variant="outlined" ></v-text-field> -->
                                    </v-col>
                                    <v-col  cols="12" md="4" sm="6">
                                        <v-combobox
                                            clearable chips multiple label="Acheteur" :items="store.state.itemsAcheteurs" v-model="filtreParams.acheteur" variant="outlined"
                                            item-value="code" item-title="libelle"
                                        ></v-combobox>
                                        <!-- <v-text-field clearable label="Acheteur"  v-model="filtreParams.acheteur" variant="outlined" ></v-text-field> -->
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col  cols="12" md="4" sm="6">
                                        <v-combobox
                                            clearable chips multiple label="Rayon" :items="itemsRayons" v-model="filtreParams.ga_familleniv1" variant="outlined"
                                            
                                        ></v-combobox>
                                        <!-- <v-text-field clearable label="Rayon"  v-model="filtreParams.ga_familleniv1" variant="outlined" ></v-text-field> -->
                                    </v-col>
                                    <v-col  cols="12" md="4" sm="6">
                                        <v-combobox
                                            clearable chips multiple label="Famille" :items="itemsFamilles" v-model="filtreParams.ga_familleniv2" variant="outlined"
                                            
                                        ></v-combobox>
                                        <!-- <v-text-field clearable label="Famille"  v-model="filtreParams.ga_familleniv2" variant="outlined" ></v-text-field> -->
                                    </v-col>
                                    <v-col  cols="12" md="4" sm="6">
                                        <v-combobox
                                            clearable chips multiple label="Sous Famille" :items="itemsSousFamilles" v-model="filtreParams.ga_familleniv3" variant="outlined"
                                            
                                        ></v-combobox>
                                        <!-- <v-text-field clearable label="Sous Famille"  v-model="filtreParams.ga_familleniv3" variant="outlined" ></v-text-field> -->
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col  cols="12" md="4" sm="6">
                                        <v-text-field clearable label="Code article"  v-model="filtreParams.ga_codearticle" variant="outlined" ></v-text-field>
                                    </v-col>
                                    <v-col  cols="12" md="4" sm="6">
                                        <v-text-field clearable label="EAN13"  v-model="filtreParams.cab_secondaire" variant="outlined" ></v-text-field>
                                    </v-col>
                                    <v-col  cols="12" md="4" sm="6">
                                        <v-text-field clearable label="Code à barre"  v-model="filtreParams.codebarre" variant="outlined" ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col  cols="12" md="6" sm="12">
                                        <v-combobox
                                            clearable chips multiple label="Collection" :items="itemsCollection" v-model="filtreParams.gl_collection" variant="outlined"
                                        ></v-combobox>
                                        <!-- <v-text-field clearable label="Collection"  v-model="filtreParams.gl_collection" variant="outlined" ></v-text-field> -->
                                    </v-col>
                                </v-row> 
                        </v-tabs-window-item>
                        <v-tabs-window-item value="tab_6">
                            <div class="d-flex justify-center">
                                <v-col  cols="12" md="6" sm="12">
                                    <v-combobox
                                        clearable chips label="Trier par" :items="itemsOrderBy" v-model="filtreParams.orderby" variant="outlined"
                                        item-value="code" item-title="libelle"
                                    ></v-combobox>
                                </v-col>
                                <v-col  cols="12" md="6" sm="12">
                                    <v-text-field clearable min="0" label="Limit" type="Number" v-model="filtreParams.limit" variant="outlined" ></v-text-field>
                                </v-col>
                            </div>
                        </v-tabs-window-item>
                        <v-tabs-window-item value="tab_5">
                            <div class="d-flex justify-center">
                                <v-col  >
                                    <v-checkbox label="Emailing" v-model="filtreParams.emailing"></v-checkbox>
                                </v-col>
                                <v-col  >
                                    <v-checkbox label="Téléphone" v-model="filtreParams.numTel"></v-checkbox>
                                
                                </v-col>
                                <v-col  >
                                    <v-checkbox label="Email" v-model="filtreParams.email"></v-checkbox>
                                </v-col>
                            </div>
                        </v-tabs-window-item>
                    </v-tabs-window>
                </v-card-text>
                
                <template v-slot:actions>
                    <div class="d-flex justify-space-between w-100">
                        <!-- Bouton Précédent toujours à gauche -->
                        <v-btn
                            text="Précédent"
                            @click="tab=`tab_${Number(tab.split('_')[1])-1}`"
                            :disabled="tab === 'tab_1'"
                        ></v-btn>
                        
                        <!-- Bouton de droite qui change selon l'onglet -->
                        <v-btn
                            v-if="tab != 'tab_6'"
                            text="Suivant"
                            @click="tab=`tab_${Number(tab.split('_')[1])+1}`"
                        ></v-btn>
                        <v-btn 
                            v-if="tab == 'tab_6' && statsToGet!='all'"
                            text="Lancer la recherche"
                            @click="tab=`tab_1`;getStats('statistiques_ventes_tiers',1);dialogueFiltre=false"
                            color="primary"
                        ></v-btn>
                         <v-btn 
                            prepend-icon="mdi-file-excel"
                            v-if="tab == 'tab_6' && statsToGet!='all'"
                            text="Export"
                            @click="tab=`tab_1`;statsToGet='excel';getStats('statistiques_ventes_tiers',1);dialogueFiltre=false"
                            color="primary"
                        ></v-btn>
                        <v-btn 
                            v-if="tab == 'tab_6' && statsToGet=='all'"
                            text="Lancer la recherche"
                            @click="tab=`tab_1`;filtreSingleParams=filtreParams;filtreSingleParams.gp_tiers=null;getStatsTiers('search_ventes');dialogueFiltre=false"
                            color="primary"
                        ></v-btn>
                        
                    </div>
                </template>
            </v-card>
        </v-dialog>
        </div>
        
        <div class="text-center">
            <v-dialog
            v-model="dialogFields"
            width="500"
            >
            <v-card>
                <v-card-title class="text-h6 font-weight-medium">
                Gestion des colonnes
                </v-card-title>
                
                <v-card-text>
                <!-- Section: Colonnes sélectionnées -->
                <div class="mb-6">
                    <div class="text-subtitle-1 font-weight-medium mb-2 text-primary">
                    <v-icon icon="mdi-view-column" size="small" class="mr-1"></v-icon>
                    Colonnes affichées
                    </div>
                    
                    <div class="d-flex flex-wrap">
                    <v-chip
                        v-for="header in filtredHeaders"
                        :key="header.key || header.value"
                        class="ma-1"
                        closable
                        @click:close="removeFromFiltered(header)"
                        color="primary"
                        variant="flat"
                    >
                        {{ header.title || header.text }}
                    </v-chip>
                    
                    <div v-if="filtredHeaders.length === 0" class="text-caption text-medium-emphasis py-2">
                        Aucune colonne sélectionnée
                    </div>
                    </div>
                </div>
                
                <v-divider class="my-4"></v-divider>
                
                <!-- Section: Colonnes disponibles -->
                <div>
                    <div class="text-subtitle-1 font-weight-medium mb-2 text-grey-darken-1">
                    <v-icon icon="mdi-plus-box" size="small" class="mr-1"></v-icon>
                    Colonnes disponibles
                    </div>
                    
                    <div class="d-flex flex-wrap" style="overflow-y: auto; max-height: 300px;">
                    <v-chip
                        v-for="header in headers"
                        :key="header.key || header.value"
                        class="ma-1"
                        @click="addToFiltered(header)"
                        variant="outlined"
                        color="grey-darken-1"
                    >
                        {{ header.title || header.text }}
                    </v-chip>
                    
                    <div v-if="headers.length === 0" class="text-caption text-medium-emphasis py-2">
                        Toutes les colonnes sont affichées
                    </div>
                    </div>
                </div>
                </v-card-text>
                
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    variant="flat"
                    @click="dialogStatsTiers=true;dialogFields = false"
                >
                    Appliquer
                </v-btn>
                <v-btn
                    variant="text"
                    @click="dialogFields = false"
                >
                    Annuler
                </v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
        </div>
        <div class="text-center">
            <v-dialog persistent v-model="dialogSpin" 
                max-width="600"
                width="600">
                <!-- <div :class="{'pointer-events-none': dialogSpin}">
                </div> -->
                <!-- <v-card> -->
                    <div v-if="dialogErreur" class="loading-content" width="400px">
                        <p class="mt-4 text-h6">Volume de données trop grand...</p>
                        <p class="text-caption">Ajouter plus de filtre</p>
                        <!-- <template v-slot:actions> -->
                            <div >
                                <v-btn
                                    text="Ok"
                                    @click="dialogSpin=false;dialogErreur=false"
                                ></v-btn>
                            </div>
                        <!-- </template> -->
                    </div>
                    <div v-if="!dialogErreur" class="loading-content" width="400px">
                        <v-progress-circular
                            indeterminate
                            size="64"
                            width="6"
                            color="primary"
                        />
                        <p class="mt-4 text-h6">Chargement en cours...</p>
                        <p class="text-caption">Veuillez patienter</p>
                    </div>
                    <template v-slot:actions>
                        <div class="d-flex justify-space-between w-100">
                            <v-btn
                                text="Ok"
                                @click="dialogSpin=false;dialogErreur=false"
                            ></v-btn>
                        </div>
                    </template>
                <!-- </v-card> -->
                    
                

            </v-dialog>
        </div>
        
        <div  class="text-center">
            <v-dialog 
                v-model="dialogueFiltres"
                max-width="600"
                width="600" >
                    <v-card  prepend-icon="mdi-shopping-search" 
                    text="Filtres prédéfinies "
                    title="Filtrage"
                    >
                        <v-card-text >
                        <v-row style="margin-top:30px">
                            <v-btn color="primary" @click="getStatsFiltres('statistiques_ventes_tiers_etablissement_monoRayon');dialogueFiltres=false;dialogFields=true">
                                Client Mono Rayon
                            </v-btn>
                        </v-row >
                        <v-row style="margin-top:30px">
                            <v-btn color="primary" @click="getStatsFiltres('moyenne','age');dialogueFiltres=false;dialogFields=true"> 
                                Age Moyen pat Etab
                            </v-btn>
                        </v-row >
                        <v-row style="margin-top:30px">
                            <v-btn color="primary" @click="getStatsFiltres('moyenne','panierEtab');dialogueFiltres=false;dialogFields=true"> 
                                Panier Moyenne par Etab
                            </v-btn>
                        </v-row >
                         <!-- <v-row style="margin-top:30px">
                            <v-btn color="primary" @click="getStatsFiltres('moyenne','panierTiers');dialogueFiltres=false;dialogFields=true"> 
                                Panier Moyenne par Client
                            </v-btn>
                        </v-row > -->
                        <!-- <v-row style="margin-top:30px">
                            <v-btn color="primary">
                                % Par marque par Etab
                            </v-btn>
                        </v-row> -->
                        </v-card-text>
                    </v-card>
            </v-dialog>
        </div>
        <v-dialog
            v-model="imageDialog"
            width="600"
        >
            <v-card width="600">
                <v-img
                    width="600"
                    cover
                    :src="srcImage"
                ></v-img>
            </v-card>
        </v-dialog>
        
    </div>
</template>

<script setup>
import { reactive, onMounted, ref, computed, watch, toRaw, onUnmounted } from 'vue'
import axios from 'axios'
import store from './store'
import router from './router'
import draggable from 'vuedraggable'
import * as XLSX from 'xlsx';
import {
    Chart as ChartJS,
        Title,
        Tooltip,
        Legend,
        ArcElement,
        BarElement,
        CategoryScale,
        LinearScale 
    } from 'chart.js'
import { Pie, Bar } from 'vue-chartjs'
import PivotTable from './components/PivotTable.vue';
import Crosspoint from './components/Crosspoint.vue';
import Statistiques from './components/Statistiques.vue';
// import Achat12 from './Achat12.vue';
let dialogFields=ref(false)
const isBarChart = ref(false)
let isPercent = ref(false)
const stats = ref([])
const isVisible = ref(false)
const loadingMore = ref(false)
const observerTarget = ref(null)
const currentPage = ref(1)
const hasMoreData = ref(true)
let dialogueFiltreTiers=ref(false)
let imageDialog=ref(false)
let srcImage=ref()
let drag = ref(false)
let observer = null
let tab=ref('tab_1')
let dialogueDate=ref(false)
let date=ref()
let exclureDate=ref(false)
let dialogueFiltres=ref(false)
let tabTiers=ref('tab_2')
let dialogErreur=ref(false)
// const removeFromFiltered = (header) => {
//   const key = header.key || header.value
//   filtredHeaders.value = filtredHeaders.value.filter(el => (el.key || el.value) !== key)
//   headers.value.push(header)
// }

// const addToFiltered = (header) => {
//   const key = header.key || header.value
//   headers.value = headers.value.filter(el => (el.key || el.value) !== key)
//   filtredHeaders.value.push(header)
// }
// let itemsOrderBy=ref([
//     {code:'total_ttc_etablissement Asc',libelle:'TTC Asc'},
//     {code:'total_ttc_etablissement Desc',libelle:'TTC Desc'},
//     {code:'nb_ventes_etablissement Asc',libelle:'Qté Asc'},
//     {code:'nb_ventes_etablissement Desc',libelle:'Qté Desc'}])
let filtreParams=ref({
        date_debut: getFirstAndLastDayOfMonth().firstDay ,
        date_fin: getFirstAndLastDayOfMonth().lastDay ,
        date_debut_exclu: exclureDate.value?'2025-10-01':null ,
        date_fin_exclu: exclureDate.value?'2025-10-01':null ,
        gp_tiers:[] ,
        gl_etablissement: [] ,
        code_acheteur: null ,
        codepole: null ,
        ga_libreart1: null ,
        code_theme:null ,
        ga_familleniv1: null ,
        ga_familleniv2: null ,
        ga_familleniv3: null ,
        ga_codearticle:null ,
        codebarre: null ,
        cab_secondaire: null ,
        gl_collection: null ,
        motif_remise: null,
        emailing:null,
        numTel: null,
        email: null,
        orderby: 'total_ttc_desc',
        limit : null
})
let headers =ref([
    { title: 'Cde Client', align: 'start', key: 'gp_tiers' },
    { title: 'Nom', align: 'end', key: 't_libelle' },
    { title: 'Prénom', align: 'end', key: 't_prenom' },
    { title: 'Genre', align: 'end', key: 't_sexe'},
    { title: 'Age', align: 'end', key: 'age' },
    { title: 'email', align: 'end', key: 't_telephone' },
    { title: 'email', align: 'end', key: 't_email' },
    { title: 'code Postal', align: 'end', key: 't_codepostal' },
    { title: 'Ratach', align: 'end', key: 't_etablissement' },
    { title: 'Nb.pass', align: 'end', key: 'nbrpassages'},
    { title: 'D.Création', align: 'end', key: 't_datecreation' },
    { title: 'D.Modif', align: 'end', key: 't_datemodif' },
    // { title: 'Rayon', align: 'end', key: 'rayon_unique' },
])
// let headers = [
//     {  key: 'gp_tiers' },
//     {  key: 't_libelle' },
//     {  key: 't_prenom' },
//     {  key: 't_sexe'},
//     {  key: 't_anneenaissance' },
//     { title: 'email', align: 'end', key: 't_telephone' },
//     { title: 'email', align: 'end', key: 't_email' },
//     { title: 'code Postal', align: 'end', key: 't_codepostal' },
//     { title: 'Ratach', align: 'end', key: 't_etablissement' },
//     { title: 'Nb.pass', align: 'end', key: 'nbrpassages'},
//     { title: 'D.Création', align: 'end', key: 't_datecreation' },
//     { title: 'D.Modif', align: 'end', key: 't_datemodif' },
//     { title: 'Rayon', align: 'end', key: 'rayon_unique' },
// ]
function getFirstAndLastDayOfMonth(date = new Date()) {
    // Premier jour du mois
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    
    // Dernier jour du mois
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    
    // Formater en 'YYYY-MM-DD'
    const formatDate = (dateObj) => {
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    return {
        firstDay: formatDate(firstDay),
        lastDay: formatDate(lastDay),
        firstDayObj: firstDay,
        lastDayObj: lastDay
    };
}
let filtreSingleParams=ref({
        date_debut: filtreParams.value.date_debut ,
        date_fin:filtreParams.value.date_fin ,
        date_debut_exclu: exclureDate.value?'2025-10-01':null ,
        date_fin_exclu: exclureDate.value?'2025-10-01':null ,
        gp_tiers:[] ,
        gl_etablissement: null ,
        code_acheteur: null ,
        codepole: null ,
        ga_libreart1: null ,
        code_theme:null ,
        ga_familleniv1: null ,
        ga_familleniv2: null ,
        ga_familleniv3: null ,
        ga_codearticle:null ,
        codebarre: null ,
        cab_secondaire: null ,
        gl_collection: null ,
        motif_remise: null,
        emailing:null,
        numTel: null,
        email: null,
        orderby: null,
        limit : null
})
let statsTableFiltred=ref([])
let filterTiers=ref({
    t_tiers:null,
    t_libelle:null,
    t_prenom:null,
    t_sexe:null,
    t_anneenaissance:null,
    t_telephone:null,
    t_email:null,
    t_etablissement:null,
    gl_etablissement:null,
    t_codepostal:null,
    gl_totalttc:null,
    moyenne_ttc_global:null,
    nb_qtestock_global:null,
    total_ttc_global:null,
    nb_ventes_global:null

})
let itemsCollection=ref(['H21','R21','E21','H22','R22','E22','H23','R23','E23','H24','R24','E24','H25','R25','E25'])
function addTiers(tiers,value){
    if(value){
        filtreSingleParams.value.gp_tiers.push(tiers)
    }else{
        filtreSingleParams.value.gp_tiers = filtreSingleParams.value.gp_tiers.filter(el => el != tiers)
    }
}
let isChecked=ref(false)
function checkTiers(value){
    filtreSingleParams.value.gp_tiers=[]
    for(let i=0;i<statsTableFiltred.value.length; i++){
        statsTableFiltred.value[i].selected=value
        if(value){
            filtreSingleParams.value.gp_tiers.push(statsTableFiltred.value[i].gp_tiers)
        }else{
            filtreSingleParams.value.gp_tiers=[]
        }   
    }   
}

function filterStatsTable() {
    const filters = filterTiers.value
    const data = statsTable.value
    
    // Filtrer le tableau
    statsTableFiltred.value = data.filter(item => { 
        // Vérifier que l'item existe et a un t_tiers
        if (!item || !item.t_tiers) {
            return false
        }
        
        // Vérifier chaque propriété du filtre
        return Object.keys(filters).every(key => {
            const filterValue = filters[key]
            let itemValue = item[key]
            
            // Si le filtre est vide, on ignore
            if (filterValue == null || filterValue === '' || 
                (typeof filterValue === 'number' && isNaN(filterValue))) {
                return true
            }
            
            // Gérer les valeurs null/undefined dans l'item
            if (itemValue == null) {
                itemValue = ''
            }
            
            // Convertir en string pour la comparaison
            const itemStr = String(itemValue)
            const filterStr = String(filterValue)
            
            // Gestion des opérateurs de comparaison
            const trimmedFilter = filterStr.trim()
            
            // Vérifier si c'est une comparaison avec opérateur
            const operatorMatch = trimmedFilter.match(/^([<>!]=?|=)(.+)$/)
            if (operatorMatch) {
                const operator = operatorMatch[1]
                const compareValue = operatorMatch[2].trim()
                
                // Essayer de comparer comme nombres
                const itemNum = parseFloat(itemStr)
                const compareNum = parseFloat(compareValue)
                
                if (!isNaN(itemNum) && !isNaN(compareNum)) {
                    // Comparaison numérique
                    switch (operator) {
                        case '>': return itemNum > compareNum
                        case '>=': return itemNum >= compareNum
                        case '<': return itemNum < compareNum
                        case '<=': return itemNum <= compareNum
                        case '=': return itemNum === compareNum
                        case '!=':
                        case '!':
                        case '<>': return itemNum !== compareNum
                        default: return itemStr.toLowerCase().includes(compareValue.toLowerCase())
                    }
                } else {
                    // Comparaison textuelle
                    const itemLower = itemStr.toLowerCase()
                    const compareLower = compareValue.toLowerCase()
                    let regex=new RegExp(compareLower,'gmi')
                    switch (operator) {
                        case '=': return itemLower === compareLower
                        case '!=':
                        case '!': return !itemLower.match(regex)
                        case '<>': return itemLower !== compareLower
                        case '>': return itemLower > compareLower
                        case '>=': return itemLower >= compareLower
                        case '<': return itemLower < compareLower
                        case '<=': return itemLower <= compareLower
                        default: return itemLower.includes(compareLower)
                    }
                }
            }
            
            // Recherche textuelle simple (contient)
            return itemStr.toLowerCase().includes(trimmedFilter.toLowerCase())
        })
    })
    
    //console.log(`${statsTableFiltred.value.length} éléments filtrés sur ${data.length}`)
    return statsTableFiltred.value
}
    
    watch(
        filterTiers,
        (newValue, oldValue) => {
            filterStatsTable()
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
    let readyToExport=ref(true)
    watch(
        filtreSingleParams,
        (newValue, oldValue) => {
            readyToExport.value=false
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
    let axe=ref({
        x:'t_etablissement',
        y:'total_ttc_global',
        showPercent:false,
        source:'TCD'
    })
    watch(
        axe,
        (newValue, oldValue) => {
            chartData1()
        },
        { deep: true } // Important pour surveiller les changements dans l'objet
    )
    // stats présentation
    // Options séparées
        ChartJS.register(
            Title,
            Tooltip,
            Legend,
            ArcElement,
            BarElement,
            CategoryScale,
            LinearScale
        )

        const pieOptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { position: 'right' }
            }
        }

        const barOptions = {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: { beginAtZero: true }
            }
        }
        // chartData reste le même pour les deux
        const chartData = computed(() => {
            const data = chartData1()
            return {
                labels: data.tabTheme,
                datasets: [{
                label: `Données ${axe.value.showPercent?'% ':''}`,
                data: data.tabQte,
                backgroundColor: data.colorTab
                }]
            }
        })

    let grapheType=ref()
        // New
    function chartData1() {
        const qte = { autre: 0 };
        const colorTab = [generateRandomColor()];
        let sum = 0;
        
        const data = getDataSource();
        // const { axe.value.x, axe.value.y, showPercent } = axe.value;
        // axe.value.x, axe.value.y, showPercent
        // console.log({ axe.value.x, axe.value.y, showPercent } );
        
        // Traitement unique
        Object.values(data).forEach(item => {
            if (!item || item[axe.value.x] === undefined) return;
            if(item[axe.value.x] ){
                const xVal = item[axe.value.x].toString();
                const yVal = Number(item[axe.value.y]) || 0;
                
                if (!xVal) {
                    qte.autre += yVal;
                } else {
                    if (!qte[xVal]) {
                        colorTab.push(generateRandomColor());
                        qte[xVal] = yVal;
                    } else {
                        qte[xVal] += yVal;
                    }
                }
                sum += yVal;
            }
            
        });
        
        // Nettoyage et retour
        if (qte.autre === 0) {
            delete qte.autre;
            colorTab.shift();
        }
        
        const tabTheme = Object.keys(qte);
        let tabQte = Object.values(qte);
        
        if (axe.value.showPercent) {
            const factor = 100 / sum;
            tabQte = tabQte.map(value => value * factor);
        }
        // console.log({ tabTheme, colorTab, tabQte });
        
        return { tabTheme, colorTab, tabQte };
        
        function getDataSource() {
            return grapheType.value === 'tiers' 
                ? tiersTable.value
                : axe.value.source === 'GLOBAL'
                    ? statsTable.value
                    : statsTableFiltred.value;
        }
        
        function generateRandomColor() {
            return '#' + ((Math.random() * 0xFFFFFF) << 0).toString(16).padStart(6, '0');
        }
    } 
        // 


// Options du graphique
const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,

} 


let dialogStatsTiers=ref(false)
let statsTable=ref([])
let statsTiers=ref()
let tiersTable=ref([])
let tabEtabs=ref('tab_1')
let tabTiersInfos=ref('tab_2')
let dialogTiers=ref(false)
let tiers=ref()
let  formattedBirthDate = ()=>{
//   const { t_anneenaissance, t_moisnaissance, t_journaissance } = tiers.value;
  
  // Vérifier que tous les champs existent
  if (!tiers.value.t_anneenaissance || !tiers.value.t_moisnaissance || !tiers.value.t_journaissance) {
    return '';
  }
  
  // Pad avec des zéros pour les mois/jours à un chiffre
  const year = String(tiers.value.t_anneenaissance);
  const month = String(tiers.value.t_moisnaissance).padStart(2, '0');
  const day = String(tiers.value.t_journaissance).padStart(2, '0');
//   //console.log(`${year}-${month}-${day}`);
  
  return `${year}-${month}-${day}`;
};
let dialogueFiltre=ref(false)
let statsToGet=ref()
function getElement(element,niv) {
    const niveau1 = Object.values(element)[0]; 
    const niveau2 = Object.values(niveau1)[0];
    const niveau3 = Object.values(niveau2)[0];
    const niveau4 = Object.values(niveau3)[0];
    const niveau5 = Object.values(niveau4)[0];
    if(niv==1){
    return niveau5
    }else if(niv==2){
    return niveau4
    }else if(niv==3){
    return niveau3
    }else if(niv==4){
    return niveau2
    }else if(niv==5){
    return niveau1
    }
}
const initObserver = () => {
  const options = {
    root: null,
    rootMargin: '100px',
    threshold: 0.1
  }

  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !loadingMore.value && hasMoreData.value) {
        loadMore()
      }
    })
  }, options)

  if (observerTarget.value) {
    observer.observe(observerTarget.value)
  }
}
let magasins = ref({
    reflex: {code:4, 'filliale':'Reflex', 'etabliss':['WEDI','WEBE','WENL','WETR','WOOM','WCAM','WAMZ']},
    etrier: {code:5, 'filliale':'Etrier', 'etabliss':['CA24','VX05','PR25']},
    begique: {code:3, 'filliale':'Edisac Belgique', 'etabliss':['BR08','NP19','GE22','OO10']},
    nord: {code:6, 'filliale':'Edisac Nord', 'etabliss':['DK03','MN01','EN11','FT04','LI02','RO06','LO07']},
    pdc: {code:7, 'filliale':'Edisac PDC', 'etabliss':['AR09','CO18','HB21']}
})

// Items Filliale générés dynamiquement depuis magasins
let itemsFilliale = computed(() => {
    return Object.entries(magasins.value).map(([code, data]) => ({
        code: code,
        Libelle: data.filliale
    }))
})
let itemsOrderBy=ref(['ca_global','ca_etablissement','nb_ventes_global','nb_ventes_etablissement','moyenne_ttc_global','moyenne_ttc_etablissement','pourcentage_ca','derniere_vente','premiere_vente','nom_client','etablissement'])
// Item Magasins générés dynamiquement (tous les établissements)
let itemMagasins = computed(() => {
    return Object.values(magasins.value).flatMap(magasin => magasin.etabliss)
})

// Alternative: exactement le même ordre que votre code original
let itemMagasinsOriginalOrder = computed(() => {
    // Si aucune filliale sélectionnée, retourner tableau vide ou tous les magasins
    if (! filtreParams.value.filliale || filtreParams.value.filliale.length === 0) {
        // return []
        filtreParams.value.gl_etablissement = []
        // Ou si vous voulez tous les magasins quand rien n'est sélectionné :
        return Object.values(magasins.value).flatMap(magasin => magasin.etabliss)
    }
    
    // Concaténer les établissements dans l'ordre spécifique selon les filliales sélectionnées
    let result = []
    filtreParams.value.gl_etablissement = []
    // Toujours dans cet ordre spécifique : nord, pdc, begique, etrier, reflex
    const ordreFilliales = ['nord', 'pdc', 'begique', 'etrier', 'reflex']
    ordreFilliales.forEach(codeFilliale => {
        // Ajouter seulement si la filliale est sélectionnée
        if (filtreParams.value.filliale.map((x) => x=x.code).includes(codeFilliale)) {
            result.push(...(magasins.value[codeFilliale]?.etabliss || []))
            filtreParams.value.gl_etablissement.push(...(magasins.value[codeFilliale]?.etabliss || []))   
        }
    })
    return result
})
const exportToExcel = (excelData) => {
    const worksheet = XLSX.utils.json_to_sheet(excelData);
    
    
    const workbook = XLSX.utils.book_new();
    
    XLSX.utils.book_append_sheet(workbook, worksheet, `EXPORT_STATS_`);
    XLSX.writeFile(workbook, `clients_${getCurrentDateYYYYMMDD()}.xlsx`);
};
function getCurrentDateYYYYMMDD() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois commence à 0
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}${month}${day}`;
}
// drag and drop début


// Headers disponibles (ceux qui ne sont pas dans filtredHeaders)
const availableHeaders = computed(() => {
  return allHeaders.value.filter(header => 
    !filtredHeaders.value.some(fh => fh.key === header.key)
  )
})

const getHeaderKey = (header) => {
  return header.key || header.value
}

const removeFromFiltered = (header) => {
  const key = getHeaderKey(header)
  filtredHeaders.value = filtredHeaders.value.filter(h => getHeaderKey(h) !== key)
}

const addToFiltered = (header) => {
  const key = getHeaderKey(header)
  if (!filtredHeaders.value.some(h => getHeaderKey(h) === key)) {
    filtredHeaders.value.push({...header})
  }
}

const saveAndClose = () => {
  dialogFields.value = false
  // Sauvegarder les préférences
  localStorage.setItem('tableHeaders', JSON.stringify(filtredHeaders.value))
}

// Pour ouvrir le dialog depuis un parent
// const openDialog = () => {
//   dialogFields.value = true
// }

// defineExpose({
//   openDialog
// })
// drag and drop fin

function typeFiltre(tab){
    let text='filtre'
    switch (tab) {
        case 'tab_1':
            text='Veuillez Sélectionner les dates'
            break;
        case 'tab_2':
            text='Veuillez Sélectionner les établissements'
            break;
        case 'tab_3':
            text='Veuillez Sélectionner les Marques & Thèmes'
            break;
        case 'tab_4':
            text='Veuillez Sélectionner les classfications Aricles'
            break;
        case 'tab_5':
            text='Veuillez indiquer l’odre les critères Clients'
            break
        case 'tab_6':
            text='Veuillez indiquer l’odre de trie et le limit'
            break
        default:
            text='filtre'
            break;
    }
    return text
}

function setVisible(tiers,type){
    if(type=='allstats'){
        for(let etab in stats.value[tiers.gp_tiers]){
            stats.value[tiers.gp_tiers][etab].visible=!stats.value[tiers.gp_tiers][etab].visible
        }
    }else if(type=='ticket'){
         for(let ligne in statsTiers.value[tiers.gl_etablissement][tiers.numero]){
           statsTiers.value[tiers.gl_etablissement][tiers.numero][ligne].visible.ticket=!statsTiers.value[tiers.gl_etablissement][tiers.numero][ligne].visible.ticket
        }
    }else if(type=='ligne'){
        for(let ligne in statsTiers.value[tiers.gl_etablissement][tiers.numero]){
            statsTiers.value[tiers.gl_etablissement][tiers.numero][ligne].visible.ligne=!statsTiers.value[tiers.gl_etablissement][tiers.numero][ligne].visible.ligne
        }
    }
    
}
function totalTiers(tiers,etab,numero_1){
  
    let totalTTC=0
    let totalQte=0
    
    for(let etab in stats.value[tiers.gp_tiers]){
        totalTTC+=Number(stats.value[tiers.gp_tiers][etab].total_ttc_etablissement?stats.value[tiers.gp_tiers][etab].total_ttc_etablissement:stats.value[tiers.gp_tiers][etab].total_ttc_global)
        totalQte+=Number(stats.value[tiers.gp_tiers][etab].nb_ventes_etablissement?stats.value[tiers.gp_tiers][etab].nb_ventes_etablissement:stats.value[tiers.gp_tiers][etab].nb_ventes_global)
    }
    
    return {
        totalTTC:Number(totalTTC).toFixed(2),
        totalQte:totalQte
    }
}
function totalTiersDetails(etab,numero){
    let totalTTC=0
    let totalQte=0
    if(numero){
        for(let numLigne in statsTiers.value[etab][numero]){
            // console.log(statsTiers.value[etab][numero][numLigne]);
            
            totalTTC+=Number(statsTiers.value[etab][numero][numLigne].gl_totalttc)
            totalQte+=Number(statsTiers.value[etab][numero][numLigne].gl_qtestock)
        }
    }
    else {
        for(let numero in statsTiers.value[etab]){
             for(let numLigne in statsTiers.value[etab][numero]){
                totalTTC+=Number(statsTiers.value[etab][numero][numLigne].gl_totalttc)
                totalQte+=Number(statsTiers.value[etab][numero][numLigne].gl_qtestock)
            }
        }
    }
    
    return {
        totalTTC:Number(totalTTC).toFixed(2),
        totalQte:totalQte.toFixed(0)
    }
}
let itemsThemes = computed(() => {
  if (!filtreParams.value.ga_libreart1 || filtreParams.value.ga_libreart1.length === 0) {
    return [...new Set(store.state.themes.map(theme => theme.split('|')[0].trim()))]
  }

  const codesMarquesSelectionnes = filtreParams.value.ga_libreart1.map(item => {
    if (typeof item === 'string') {
      return item.split('-')[0].trim()
    } else {
      return item.code ? item.code.split('-')[0].trim() : ''
    }
  }).filter(code => code !== '')

  return [...new Set(store.state.themes
    .filter(theme => {
      const themeParts = theme.split('|')
      if (themeParts.length < 2) return false
      
      const codeMarqueTheme = themeParts[1].trim()
      return codesMarquesSelectionnes.includes(codeMarqueTheme)
    })
    .map(theme => theme.split('|')[0].trim()))]
})
let itemsRayons = computed(() => {
  if (!filtreParams.value.ga_libreart1 || filtreParams.value.ga_libreart1.length === 0) {
    return [...new Set(store.state.rayons.map(Rayon =>`${Rayon.split('|')[1].trim()} - ${Rayon.split('|')[2].trim()}` ))]
  }

  const codesMarquesSelectionnes = filtreParams.value.ga_libreart1.map(item => {
    if (typeof item === 'string') {
      return item.split('-')[0].trim()
    } else {
      return item.code ? item.code.split('-')[0].trim() : ''
    }
  }).filter(code => code !== '')

  return [...new Set(store.state.rayons
    .filter(Rayon => {
      const RayonsParts = Rayon.split('|')
    //   //console.log(RayonsParts);
      
      if (RayonsParts.length < 2) return false
    //   //console.log(codesMarquesSelectionnes);
      
      const codeMarqueRayons = RayonsParts[0].trim()
      return codesMarquesSelectionnes.includes(codeMarqueRayons)
    })
    .map(Rayon =>`${Rayon.split('|')[1].trim()} - ${Rayon.split('|')[2].trim()}` ))]
})
let itemsFamilles = computed(() => {
  if (!filtreParams.value.ga_libreart1 || filtreParams.value.ga_libreart1.length === 0) {
    return [...new Set(store.state.familles.map(Famille =>`${Famille.split('|')[2].trim()} - ${Famille.split('|')[3].trim()}` ))]
  }

  const codesMarquesSelectionnes = filtreParams.value.ga_libreart1.map(item => {
    if (typeof item === 'string') {
      return item.split('-')[0].trim()
    } else {
      return item.code ? item.code.split('-')[0].trim() : ''
    }
  }).filter(code => code !== '')

  return [...new Set(store.state.familles
    .filter(Famille => {
      const FamillesParts = Famille.split('|')
    //   //console.log(RayonsParts);
      
      if (FamillesParts.length < 2) return false
    //   //console.log(codesMarquesSelectionnes);
      
      const codeMarqueFamilles = FamillesParts[0].trim()
      return codesMarquesSelectionnes.includes(codeMarqueFamilles)
    })
    .map(Famille =>`${Famille.split('|')[2].trim()} - ${Famille.split('|')[3].trim()}` ))]
})
let itemsSousFamilles = computed(() => {
  if (!filtreParams.value.ga_libreart1 || filtreParams.value.ga_libreart1.length === 0) {
    return [...new Set(store.state.sousFamilles.map(SousFamille =>`${SousFamille.split('|')[3].trim()} - ${SousFamille.split('|')[4].trim()}` ))]
  }

  const codesMarquesSelectionnes = filtreParams.value.ga_libreart1.map(item => {
    if (typeof item === 'string') {
      return item.split('-')[0].trim()
    } else {
      return item.code ? item.code.split('-')[0].trim() : ''
    }
  }).filter(code => code !== '')

  return [...new Set(store.state.sousFamilles
    .filter(SousFamille => {
      const SousFamillesParts = SousFamille.split('|')
    //   //console.log(RayonsParts);
      
      if (SousFamillesParts.length < 2) return false
    //   //console.log(codesMarquesSelectionnes);
      
      const codeMarqueSousFamilles = SousFamillesParts[0].trim()
      return codesMarquesSelectionnes.includes(codeMarqueSousFamilles)
    })
    .map(SousFamille =>`${SousFamille.split('|')[3].trim()} - ${SousFamille.split('|')[4].trim()}` ))]
})
let loading=ref(false)
let dialogSpin=ref(false)
async function getStatsTiers(type,tiers){
    
    dialogSpin.value=true
    if(tiers){
        filtreSingleParams.value.gp_tiers.push(tiers)
    }
    filtreSingleParams.value = {
        ...filtreSingleParams.value,
        filliale: null,
        gl_etablissement:filtreSingleParams.value.gl_etablissement&&filtreSingleParams.value.gl_etablissement.length==0?filtreSingleParams.value.gl_etablissement.map(x=>x=x.code):null ,
        // gp_tiers: filtreSingleParams.value.gp_tiers?filtreSingleParams.value.gp_tiers.map(x=>x=x.code):null  ,
        codepole: filtreSingleParams.value.codepole?filtreSingleParams.value.codepole.map(x=>x=x.code):null  ,
        ga_libreart1: filtreSingleParams.value.ga_libreart1?filtreSingleParams.value.ga_libreart1.map(x=>x=x.split("-")[0].trim()):null  ,
        code_theme:filtreSingleParams.value.code_theme?filtreSingleParams.value.code_theme.map(x=>x=x.split("-")[0].trim()):null  ,
        ga_familleniv1: filtreSingleParams.value.ga_familleniv1?filtreSingleParams.value.ga_familleniv1.map(x=>x=x.split('-')[0].trim()):null  ,
        ga_familleniv2: filtreSingleParams.value.ga_familleniv2?filtreSingleParams.value.ga_familleniv2.map(x=>x=x.split('-')[0].trim()):null  ,
        ga_familleniv3: filtreSingleParams.value.ga_familleniv3?filtreSingleParams.value.ga_familleniv3.map(x=>x=x.split('-')[0].trim()):null 
    }

        grapheType.value='tiers';
        axe.value={x:'gl_etablissement',y:'gl_totalttc'};
         let url = `https://my.edisac.com/api/statistics/${type}`
        let config = {
            method: 'post',
            url: url,
            data:filtreSingleParams.value
        }
        
        return axios.request(config)
            .then((response) => { 
                if(response.data.statut=='erreur'){
                    loading.value=false
                    dialogErreur.value=true
                }else if (response.data.tiersTable.length==0){
                    dialogueFiltreTiers.value=true
                }else{
                    //console.log(response.data.tiersTable);
                    
                    statsTiers.value=response.data.stats
                    tiersTable.value=response.data.tiersTable
                    dialogStatsTiers.value=true;
                    statsTiersDialog.value=true
                    loading.value=false
                    readyToExport.value=true
                    dialogSpin.value=false
                    //console.log(filtreSingleParams.value.gp_tiers);
                    
                    if(filtreSingleParams.value.gp_tiers.length==1){
                        getClients(filtreSingleParams.value.gp_tiers[0])
                    }
                    
                }
                
            })
            .catch((error) => {
            //console.log(error)
            })
    // }
    
}
function validerFormatTelephone(numero) {
  // Vérifie si le numéro est au format français ou belge
  return numero.startsWith('33') || numero.startsWith('32');
}
function formaterTelephoneComplet(numero) {
  if (!numero) return '';
  
  // Supprimer tous les caractères non numériques
  const numeroNettoye = numero.toString().replace(/\D/g, '');
  
  // Si le numéro est déjà au format international avec +
  if (numeroNettoye.startsWith('33') && numeroNettoye.length === 11) {
    return '' + numeroNettoye;
  }
  
  if (numeroNettoye.startsWith('32') && numeroNettoye.length === 11) {
    return '' + numeroNettoye;
  }
  
  // Si le numéro est au format international avec 00
  if (numeroNettoye.startsWith('0033') && numeroNettoye.length === 13) {
    return '33' + numeroNettoye.substring(4);
  }
  
  if (numeroNettoye.startsWith('0032') && numeroNettoye.length === 13) {
    return '32' + numeroNettoye.substring(4);
  }
  
  // Appliquer les règles pour les numéros français et belges
  if (numeroNettoye.startsWith('06') || numeroNettoye.startsWith('07')) {
    // Vérifier que c'est un numéro français complet (10 chiffres)
    if (numeroNettoye.length === 10) {
      return '33' + numeroNettoye.substring(1);
    }
  } else if (numeroNettoye.startsWith('04')) {
    // Vérifier que c'est un numéro belge complet (10 chiffres)
    if (numeroNettoye.length === 10) {
      return '32' + numeroNettoye.substring(1);
    }
  }
  
  // Retourner le numéro nettoyé pour les autres cas
  return numeroNettoye;
}
async function getClients(code_tiers){   

    let url=    `https://my.edisac.com/api/clients`
    let config = {
    method: 'get',
    url: url,
    params : {
        tiers:code_tiers
    }
    };
    return   axios.request(config)
    .then((response) => {
        //console.log(response.data[0]);
        
        tiers.value=response.data[0] 
        tiers.value.t_datenaissance=formattedBirthDate()
        
    })
    .catch((error) => {
    //console.log(error);
    });

}
let filtredHeaders=ref([])
let excelDataToExport=ref([])
let allHeaders = ref([
  { key: 'id', title: 'ID', value: 'id' },
  { key: 'name', title: 'Nom', value: 'name' },
  { key: 'email', title: 'Email', value: 'email' },
  { key: 'phone', title: 'Téléphone', value: 'phone' },
  { key: 'address', title: 'Adresse', value: 'address' },
  { key: 'status', title: 'Statut', value: 'status' },
  { key: 'date', title: 'Date', value: 'date' }
])
let statsTableFilters=ref([])
let statsTiersDialog=ref(false)
async function getStatsFiltres(typeStats,type){
//   store.commit('updateWaiting')
    filtredHeaders.value=[]
    allHeaders.value=[]
    dialogSpin.value=true
    let params = {
        type:type
    }
  //console.log(params);
  
  let url = `https://my.edisac.com/api/statistics/${typeStats}` 
//   let url = `https://my.edisac.com/api/statistics/${type}?page=${page},statsToGet=${statsToGet.value}`
  let config = {
    method: 'get',
    url: url,
    params: params
  }
  
  return axios.request(config)
    .then((response) => { 
            statsTableFilters.value=response.data.tiersTable
            headers.value=Object.keys(response.data.tiersTable[0]).map(x=>x={title:x,key:x})
            //console.log(response.data.tiersTable)
            dialogSpin.value=false
            // dialogTiers.value=true
            // dialogueFiltreTiers
    })
    .catch((error) => {
      //console.log(error)
      dialogSpin.value=false
    })
}
async function exportClient(){
  let url = `https://my.edisac.com/api/clients` 
//   let url = `https://my.edisac.com/api/statistics/${type}?page=${page},statsToGet=${statsToGet.value}`
  let config = {
    method: 'post',
    url: url,
    data: tiers.value
  }
  return axios.request(config)
    .then((response) => {
        //console.log(response.data);
        if(route.query.client_id){
            router.replace({ path: '/login' }) 
        }
        
     })
}
async function getStats(type,page = 1){
//   store.commit('updateWaiting')
    // filtredHeaders.value=[]
    // allHeaders.value=[]
    dialogSpin.value=true
    let params = {
        ...filtreParams.value,
        filliale: null,
        codepole: filtreParams.value.codepole?filtreParams.value.codepole.map(x=>x=x.code):null  ,
        ga_libreart1: filtreParams.value.ga_libreart1?filtreParams.value.ga_libreart1.map(x=>x=x.split("-")[0].trim()):null  ,
        code_theme:filtreParams.value.code_theme?filtreParams.value.code_theme.map(x=>x=x.split("-")[0].trim()):null  ,
        ga_familleniv1: filtreParams.value.ga_familleniv1?filtreParams.value.ga_familleniv1.map(x=>x=x.split('-')[0].trim()):null  ,
        ga_familleniv2: filtreParams.value.ga_familleniv2?filtreParams.value.ga_familleniv2.map(x=>x=x.split('-')[0].trim()):null  ,
        ga_familleniv3: filtreParams.value.ga_familleniv3?filtreParams.value.ga_familleniv3.map(x=>x=x.split('-')[0].trim()):null ,
        emailing: filtreParams.value.emailing?true:null,
        numTel: filtreParams.value.numTel?true:null,
        email: filtreParams.value.email?true:null
    }
  //console.log(params);
  
  let url = `https://my.edisac.com/api/statistics/${type}?page=${page},statsToGet=${statsToGet.value}` 
//   let url = `https://my.edisac.com/api/statistics/${type}?page=${page},statsToGet=${statsToGet.value}`
  let config = {
    method: 'get',
    url: url,
    params: params
  }
  
  return axios.request(config)
    .then((response) => { 
        // headers.value=Object.keys(response.data.tiersTable[0]).map(x=>x={title:x,key:x})
      const newData = response.data[Object.keys(response.data)[0]]
      const newDataTable = response.data.tiersTable
      if(statsToGet.value=='excel'){
        if(filtreParams.value.numTel&&!filtreParams.value.email){
            excelDataToExport.value=newDataTable.map(x=>x={telephone:formaterTelephoneComplet(x.t_telephone)}).filter(item => validerFormatTelephone(item.telephone));
        }else if(filtreParams.value.email){
            excelDataToExport.value=newDataTable.map(x=>x={Prenom:x.t_prenom,Nom:x.t_libelle,Email:x.t_email,Telephone:formaterTelephoneComplet(x.t_telephone),Etablissement:x.t_etablissement}).filter(item => item.Email!='')
        }
        else{
            excelDataToExport.value=newDataTable.map(x=>x={Prenom:x.t_prenom,Nom:x.t_libelle,Email:x.t_email,Telephone:formaterTelephoneComplet(x.t_telephone),Etablissement:x.t_etablissement})
        }
        
        exportToExcel(excelDataToExport.value)
      }else{
            
            stats.value = newData
            statsTable.value =newDataTable
            statsTableFiltred.value=statsTable.value
            // console.log(Object.keys(statsTable.value[0]))
            // headers.value=Object.keys(response.data.tiersTable[0]).map(x=>x={title:x,key:x})
            // console.log(headers.value)
            // console.log(statsTable.value)
            isVisible.value = true
      }
      dialogSpin.value=false
    })
    .catch((error) => {
      //console.log(error)
      dialogSpin.value=false
      hasMoreData.value = false
    })
}

// Charger plus de données
let pageToLoad=ref(1)
const loadMore = async () => {
  if (loadingMore.value || !hasMoreData.value) return
  
  loadingMore.value = true
  try {
    await getStats('statistiques_ventes_tiers_etablissement',pageToLoad.value)
    pageToLoad.value++
  } finally {
    loadingMore.value = false
  }
}

// Chargement initial
const loadInitialData = async () => {
  await getStats('statistiques_ventes_tiers_etablissement',1)
}

async function getArticles(reference){
        
        let params=
        {   
            reference:reference.codebarre
        }
        let url=    `https://my.edisac.com/api/articlesdeep`
        let config = {
        method: 'get',
        url: url,
        params:params
        };
        return   axios.request(config)
        .then((response) => {
            srcImage.value=`https://www.edisac.com/images/article_la/${response.data.articles[reference.ga_libreart1][reference.code_theme][reference.ga_codearticle][reference.codebarre].imagename}`
            imageDialog.value=true
        })
        .catch((error) => {
        //console.log(error);
        });
        
    }
    const itemsPerPage = ref(20)
    const pageCount = computed(() => {
  return Math.ceil(filteredItems.value.length / itemsPerPage.value)
})

const paginatedItems = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value
  const end = start + itemsPerPage.value
  return statsTableFiltred.value.slice(start, end)
})

const startIndex = computed(() => {
  return (currentPage.value - 1) * itemsPerPage.value
})

const endIndex = computed(() => {
  return startIndex.value + itemsPerPage.value
})

const selectedCount = computed(() => {
  return filteredItems.value.filter(tiers => tiers.selected).length
})
const filteredItems = computed(() => {
  return statsTableFiltred.value
// .filter(tiers => {
//     // Filtrage par tous les champs
//     for (const [key, value] of Object.entries(filterTiers.value)) {
//       if (value && value.toString().trim() !== '') {
//         const itemValue = tiers[key]?.toString().toLowerCase() || ''
//         const filterValue = value.toString().toLowerCase()
        
//         // Traitement spécial pour l'âge
//         if (key === 'age') {
//           const age = calculateAge(tiers.t_anneenaissance)
//           if (age !== parseInt(value)) return false
//           continue
//         }
        
//         // Filtre normal
//         if (!itemValue.includes(filterValue)) return false
//       }
//     }
    
//     return true
// })
})
// const totalTiers = (tiers) => {
//   // Votre logique existante
//   return {
//     totalQte: tiers.totalQte || 0,
//     totalTTC: tiers.totalTTC || 0
//   }
// }

// const setVisible = (tiers, type) => {
//   // Votre logique existante
//   //console.log('setVisible', tiers, type)
// }

const getVisibleEtabs = (tiersCode) => {
  const tiersStats = stats.value[tiersCode]
  if (!tiersStats) return []
  
  return Object.values(tiersStats).filter(etab => 
    etab && etab.visible
  )
}

const calculateAge = (anneeNaissance) => {
  if (!anneeNaissance || anneeNaissance === '1900') return ''
  return new Date().getFullYear() - parseInt(anneeNaissance)
}

// Méthodes de pagination
const applyFilters = () => {
  currentPage.value = 1 // Réinitialiser à la première page lors du filtrage
}

const visiblePages = computed(() => {
  const pages = []
  const totalPages = pageCount.value
  const current = currentPage.value
  
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i)
    }
  } else {
    if (current <= 4) {
      for (let i = 1; i <= 5; i++) {
        pages.push(i)
      }
      pages.push('...')
      pages.push(totalPages)
    } else if (current >= totalPages - 3) {
      pages.push(1)
      pages.push('...')
      for (let i = totalPages - 4; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      pages.push(1)
      pages.push('...')
      for (let i = current - 1; i <= current + 1; i++) {
        pages.push(i)
      }
      pages.push('...')
      pages.push(totalPages)
    }
  }
  
  return pages
})
const resetPage = () => {
  currentPage.value = 1
}

const goToPage = (pageNum) => {
  if (pageNum !== '...' && pageNum >= 1 && pageNum <= pageCount.value) {
    currentPage.value = pageNum
  }
}

const nextPage = () => {
  if (currentPage.value < pageCount.value) {
    currentPage.value++
  }
}

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const firstPage = () => {
  currentPage.value = 1
}

const lastPage = () => {
  currentPage.value = pageCount.value
}

// ajout params
import { useRoute, onBeforeRouteUpdate } from 'vue-router'
const route = useRoute()
const loadParams = () => {
      //console.log(route.query);
      if(route.query.client_id){
          try {
              // currentUrl.value = window.location.href
            if(route.query.client_id){
            getStatsTiers('search_ventes',route.query.client_id)
            getClients(route.query.client_id)
            //console.log(route);
            store.commit('addUser',{groupe:'N'})
            tabTiers.value="tab_3"
            statsTiersDialog.value=true
                // availableEtablissements.value = etab.value
                // selectedEtab.value=route.query.etab.toUpperCase()
                // loadData()
            }
              
          } catch (err) {
              // error.value = err.message
          }
      }
  }
//
onBeforeRouteUpdate((to, from) => {
    loadParams()
})


onMounted(() => {
  // Initialiser l'observer après le montage
//   setTimeout(() => {
//     initObserver()
//   }, 100)
  
  // Charger les premières données 
//   loadInitialData()

    getStats('statistiques_ventes_tiers',1)
    loadParams()
})

onUnmounted(() => {
  // Nettoyer l'observer
  if (observer) {
    observer.disconnect()
  }
})
</script>

<style scoped>
.iconAdd{
cursor: pointer;
}
.iconAdd:hover{
background-color: orange;
}
.observer-target {
  height: 1px;
  width: 100%;
  opacity: 0;
}

.loading-indicator {
  text-align: center;
  padding: 20px;
  color: #666;
}

.load-more-btn {
  margin: 20px auto;
  display: block;
}
.chart-container {
  width: 900px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
.chart-container-pie {
  width: 1000px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
.chart-container-bar {
  width: 1000px;    /* Largeur souhaitée */
  height: 400px;   /* Hauteur souhaitée */
  position: relative;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* Bloque TOUS les événements de souris */
  cursor: not-allowed !important;
  pointer-events: all !important;
}

.loading-overlay * {
  pointer-events: none !important;
}

.loading-content {
  background: white;
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  
  /* Permet les clics dans le contenu du loader */
  pointer-events: auto !important;
}

.pointer-events-none {
  pointer-events: none !important;
  user-select: none !important;
  cursor: not-allowed !important;
}

/* Empêche la sélection de texte */
.pointer-events-none * {
  user-select: none !important;
}

.client-table-container {
  width: 100%;
  overflow-x: auto;
}

.client-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 0;
}

.client-table th,
.client-table td {
  border: 0.1em solid #ddd;
  padding: 4px;
  text-align: left;
  vertical-align: middle;
  height: 32px;
  box-sizing: border-box;
}

.client-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 10;
}

.client-table input[type="text"] {
  width: 100%;
  box-sizing: border-box;
  padding: 2px 4px;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 12px;
}

.client-table input[type="checkbox"] {
  margin: 0;
  transform: scale(0.9);
}

.clickable {
  cursor: pointer;
  transition: background-color 0.2s;
}

.clickable:hover {
  background-color: #f0f0f0;
}

.iconAdd {
  color: #1976d2;
}

.disabled-icon {
  opacity: 0.5;
  cursor: not-allowed;
}

.no-results {
  text-align: center;
  padding: 20px;
  color: #666;
  font-style: italic;
  border: 1px solid #ddd;
  margin-top: -1px;
  background-color: #f9f9f9;
}

/* Pagination Styles */
.pagination-container {
  margin-top: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pagination-info {
  font-size: 14px;
  color: #666;
}

.pagination-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.items-per-page {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.items-per-page select {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  background-color: white;
  font-size: 14px;
}

.pagination-nav {
  display: flex;
  align-items: center;
  gap: 5px;
}

.pagination-nav button {
  padding: 4px 10px;
  border: 1px solid #ccc;
  background-color: white;
  border-radius: 3px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  min-width: 32px;
  height: 32px;
}

.pagination-nav button:hover:not(:disabled) {
  background-color: #f0f0f0;
  border-color: #999;
}

.pagination-nav button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-nav button.active {
  background-color: #1976d2;
  color: white;
  border-color: #1976d2;
}

.page-numbers {
  display: flex;
  gap: 5px;
  margin: 0 10px;
}

.page-numbers button:disabled {
  background-color: transparent;
  border-color: transparent;
  cursor: default;
}
.drag-area {
  min-height: 60px;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 8px;
  transition: border-color 0.3s;
}

.drag-area:hover {
  border-color: #1976d2;
}

.ghost-item {
  opacity: 0.5;
  background: #e0e0e0;
}

.chosen-item {
  background: #e3f2fd;
}

.v-chip {
  cursor: move;
  transition: all 0.2s;
}

.v-chip:hover {
  transform: scale(1.05);
}

/* Responsive */
@media (max-width: 1200px) {
  .client-table-container {
    font-size: 12px;
  }
  
  .client-table th,
  .client-table td {
    padding: 2px 3px;
  }
  
  .pagination-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .items-per-page {
    justify-content: center;
  }
  
  .pagination-nav {
    justify-content: center;
  }
}
</style>